// /**
//  * 【标题】:
//  * 【描述】:
//  * 【版权】:
//  * 【作者】:
//  * 【时间】: 2018/12/27 9:56
//  */
// // const SERVER_BASE_URL = 'http://192.168.1.36:81/';
// const SERVER_BASE_URL = window.location.origin+'/';
// // const SERVER_BASE_URL = 'http://www.plcgx.com/';
// const SERVER_BASE_URL2 = window.location.origin+'/';
// // const TRADER_URL = 'trader-1/#/';
// // const CALENDAR_URL = 'http://192.168.1.203/quanzi/#/calendar/index';
// // const NEWSFLASH_URL = 'http://192.168.1.203/quanzi/#/newsFlash';
// // const LOGIN_URL = '';

// // 测试
// const origin = window.location.origin;
// let LOGIN_URL = '';
// let ENl = '';
// let REGIST_URL = '';
// if(origin.indexOf('192.168.1.36') !=-1){
//    LOGIN_URL = 'http://192.168.1.36:81/trader/zh-hans/#/signIn?redirect=%2F';
//    ENl = 'http://192.168.1.36:81';
//    REGIST_URL = 'http://192.168.1.36:81/trader/zh-hans/#/signUp';
// } else if(origin.indexOf('http://qa.rtdream.cn') !=-1) {
//   LOGIN_URL = 'http://qa.rtdream.cn:8888/trader/zh-hans/#/signIn?redirect=%2F';
//   ENl = 'http://qa.rtdream.cn:8888';
//   REGIST_URL = 'http://qa.rtdream.cn:8888/trader/zh-hans/#/signUp';
// } else {
//    LOGIN_URL = 'http://www.plcgx.com/trader/zh-hans/#/signIn?redirect=%2F';
//    ENl = 'http://www.plcgx.com';
//    REGIST_URL = 'http://www.plcgx.com/trader/zh-hans/#/signUp';
// }


// const TWITTER = 'https://twitter.com/';
// const GOOGLE = 'https://www.google.com/gmail/about/';
// const FACEBOOK = 'https://www.facebook.com/';
// const INSTAG = 'https://www.instagram.com/';
// const TELEGR = 'https://telegram.org/';
// const MEDIUM = 'https://medium.com';
// const YOUTU = 'https://www.youtube.com/';
// const CALENDAR_URL = 'https://qa.rtdream.cn/#/calendar/index';
// const NEWSFLASH_URL = 'https://qa.rtdream.cn/#/newsFlash';
// const PDF_URL = 'http://www.plcgx.com/contract.pdf';
// const PDF_ACT = 'http://www.plcgx.com/commpanyact.docx';
// const PDF_ACT2 = 'https://www.plcgx.com/BrokerAgreement.pdf';
// const PLCG_EXE = 'http://www.plcgx.com/plcg.exe';


// export default {
//   PDF_ACT2,
//   SERVER_BASE_URL,
//   SERVER_BASE_URL2,
//   LOGIN_URL,
//   ENl,
//   REGIST_URL,
//   TWITTER,
//   GOOGLE,
//   FACEBOOK,
//   INSTAG,
//   TELEGR,
//   MEDIUM,
//   YOUTU,
//   CALENDAR_URL,
//   NEWSFLASH_URL,
//   PDF_URL,
//   PDF_ACT,
//   PLCG_EXE,
// };
/**
 * 【标题】:
 * 【描述】:
 * 【版权】:
 * 【作者】:
 * 【时间】: 2018/12/27 9:56
 */
// const SERVER_BASE_URL = 'http://192.168.1.36:81/';
const SERVER_BASE_URL2 = window.location.origin+'/';
const SERVER_BASE_URL = 'https://trade.yfqha.com'+'/';
// const TRADER_URL = 'trader-1/#/';
// const CALENDAR_URL = 'http://192.168.1.203/quanzi/#/calendar/index';
// const NEWSFLASH_URL = 'http://192.168.1.203/quanzi/#/newsFlash';
// const LOGIN_URL = '';

// 测试
const origin = window.location.origin;
let LOGIN_URL = 'https://www.plcgx.com/exchange/sign-in';
let CHINESE = '';
let REGIST_URL = 'https://www.plcgx.com/exchange/sign-up';
// if(origin.indexOf('192.168.1.36') !=-1){
//    LOGIN_URL = 'http://192.168.1.36:81/trader/en-us/#/signIn?redirect=%2F';
//    CHINESE = 'http://192.168.1.36:81/zh-cn/#/';
//    REGIST_URL = 'http://192.168.1.36:81/trader/en-us/#/signUp';
// } else if(origin.indexOf('http://qa.rtdream.cn') !=-1) {
//   LOGIN_URL = 'http://qa.rtdream.cn:8888/trader/en-us/#/signIn?redirect=%2F';
//   CHINESE = 'http://qa.rtdream.cn:8888/zh-cn/#/';
//   REGIST_URL = 'http://qa.rtdream.cn:8888/trader/en-us/#/signUp';
// } else {
//    LOGIN_URL = 'http://www.plcgx.com/trader/en-us/#/signIn?redirect=%2F';
//    CHINESE = 'http://www.plcgx.com/zh-cn/#/';
//    REGIST_URL = 'http://www.plcgx.com/trader/en-us/#/signUp';
// }
// const CHINESE = 'http://www.plcgx.com/zh-cn/#/';
// const LOGIN_URL = 'http://www.plcgx.com/trader/en-us/#/signIn?redirect=%2F';
// const REGIST_URL = 'http://www.plcgx.com/trader/en-us/#/signUp';

const TWITTER = 'https://twitter.com/';
const GOOGLE = 'https://www.google.com/gmail/about/';
const FACEBOOK = 'https://www.facebook.com/';
const INSTAG = 'https://www.instagram.com/';
const TELEGR = 'https://telegram.org/';
const MEDIUM = 'https://medium.com';
const YOUTU = 'https://www.youtube.com/';
const CALENDAR_URL = 'https://qa.rtdream.cn/#/calendar/index';

const NEWSFLASH_URL = 'https://qa.rtdream.cn/#/newsFlash';
const PDF_URL = 'http://www.plcgx.com/contracten.pdf';
const PDF_ACTEN = 'http://www.plcgx.com/commpanyacten.docx';
const PLCG_EXE = 'https://www.plcgx.com/download/windows/plcg.exe';
const PDF_ACT2 = 'https://www.plcgx.com/BrokerAgreement.pdf';

export default {
  PDF_ACT2,
  SERVER_BASE_URL,
  SERVER_BASE_URL2,
  LOGIN_URL,
  REGIST_URL,
  TWITTER,
  GOOGLE,
  FACEBOOK,
  INSTAG,
  TELEGR,
  MEDIUM,
  YOUTU,
  CALENDAR_URL,
  NEWSFLASH_URL,
  CHINESE,
  PDF_URL,
  PDF_ACTEN,
  PLCG_EXE,
};



// WEBPACK FOOTER //
// ./src/common/baseConfig.js